// extracted by mini-css-extract-plugin
export default {"grid":"constructor-grid_grid__QCj6p"};